export class Login {
    username = '';
    password = '';
    rememberMe = false;
}